// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IKDh","toggle":"styles_toggle__34fd6","preview":"styles_preview__2RGSB"};